import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import PeriodPicker from "./PeriodPicker";

export default withStyles(styles, { name: "HvTimePickerPeriodPicker" })(PeriodPicker);
